import { Reducer } from 'redux'

import { ActionTypes as CitationActionTypes } from '@chegg-wt/core/state/citation/constants'
import {
  FORM_FETCH_SUCCEEDED,
  FORM_REQUESTED,
  FORM_SUBMIT_FAILED,
  FORM_SUBMIT_REQUESTED,
  FORM_SUBMIT_SUCCEEDED,
  FORM_SUBMIT_START,
  FORM_SUBMIT_STOP,
  FORM_TITLE_FETCHED,
} from './constants'
import { FormState } from './types'

export const initialState: FormState = {
  html: '',
  isSubmitting: false,
  capitalizedTitle: '',
}

export const formReducer: Reducer<FormState> = (state = initialState, action) => {
  switch (action.type) {
    case FORM_REQUESTED:
      return {
        ...state,
        html: '',
      }
    case FORM_FETCH_SUCCEEDED:
      return {
        ...state,
        html: action.payload.form,
      }

    case FORM_TITLE_FETCHED:
      return {
        ...state,
        capitalizedTitle: action.payload.title,
      }
    case CitationActionTypes.CITATION_CREATE:
    case CitationActionTypes.CITATION_UPDATE:
    case FORM_SUBMIT_REQUESTED:
    case FORM_SUBMIT_START:
      return {
        ...state,
        isSubmitting: true,
      }
    case CitationActionTypes.CITATION_CREATE_SUCCEEDED:
    case CitationActionTypes.CITATION_CREATE_FAILED:
    case CitationActionTypes.CITATION_UPDATE_SUCCEEDED:
    case CitationActionTypes.CITATION_UPDATE_FAILED:
    case FORM_SUBMIT_SUCCEEDED:
    case FORM_SUBMIT_FAILED:
    case FORM_SUBMIT_STOP:
      return {
        ...state,
        isSubmitting: false,
      }
    default:
      return state
  }
}

export default formReducer
